<template>
  <v-card justify="center" min-width="300">
    <v-toolbar color="#7400b8" dark flat>
      <v-toolbar-title>
        Iniciar sesión
      </v-toolbar-title>
    </v-toolbar>
    <v-form @submit.prevent="login()">
      <v-card-text>
        <v-text-field label="Correo" name="login" prepend-icon="mdi-email" color="##7400b8" v-model="email" type="text"/>
        <v-text-field id="password" label="Contraseña" name="password" color="#7400b8" prepend-icon="mdi-lock"
                      v-model="password" type="password"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn dark color="#7400b8" type="submit">
          <v-progress-circular indeterminate v-if="waiting"/>
          <div v-else>
            Iniciar sesión
          </div>
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import axios from "axios";
const BASE_URL = process.env.VUE_APP_API_URL

export default {
  name: "LoginForm",
  data: () => ({
    email: '',
    password: '',
    waiting: false,
  }),
  methods: {
    login() {
      this.waiting = true;
      const path = BASE_URL + 'user/auth/login/'
      axios({
        method: 'post',
        url: path,
        data: {
          email: this.email,
          password: this.password,
        }
      }).then(res => {
        const path = BASE_URL + 'users/'
        let token = res.data.key;
        axios({
          method: 'get',
          url: path,
          headers: {
            Authorization: 'Token ' + token
          }
        }).then(res => {
          let user_id = res.data.results[0]['id'];
          let url_token = res.data.results[0]['url_tokens'][0]
          this.$router.push('/2024/' + user_id + '/' + url_token)
        })
      }).catch(() => {
        this.$router.push('/error');
      })
    },
  },
}
</script>

<style scoped>
</style>
